export default __webpack_public_path__ + "static/Service Advantage – Horizontal 800x400-7189a74eb49f6f9d62ce9ca356f74a88.svg";